module.exports = __webpack_public_path__ + "77418f18d9a4710c075608dd337dd4dd.png";